module.exports = __webpack_public_path__ + "img/stone-path-4.61434189.png";